import { createApi } from '@reduxjs/toolkit/query/react';

import type { BehandlingsvalgDto } from '../types/cms';

import type LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { CmsContentApiVersions } from '@helsenorge/framework-utils/cms-content-api-service';
import { getBaseQuery } from '@helsenorge/framework-utils/cms-content-api-service-redux';

const behandlingsvalgApi = createApi({
  reducerPath: 'behandlingsvalgApi',
  baseQuery: getBaseQuery,
  endpoints: builder => ({
    getBehandlingsvalg: builder.query<BehandlingsvalgDto, { behandlingsvalgNavn: string; language: LanguageLocales }>({
      query: ({ behandlingsvalgNavn, language }) => [
        'behandlingsvalg',
        { navn: behandlingsvalgNavn, languageCode: language },
        CmsContentApiVersions.V2,
      ],
    }),
  }),
});

export const { useGetBehandlingsvalgQuery } = behandlingsvalgApi;

export default behandlingsvalgApi;
